import { SendFeedbackWebComponent } from './component/SendFeedbackWebComponent';
import { WEB_COMPONENT_FEEDBACK_CARD } from '../../webcomponents.constants';
export { SendFeedbackWebComponent };
window.customElements.define(WEB_COMPONENT_FEEDBACK_CARD, SendFeedbackWebComponent);
